import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import styles from './Search.module.css'
import { searchActions, patientActions } from '_actions';
import { SearchResult } from './SearchResult'

class HeaderSearch extends React.Component {

    searchDetails() {
        this.props.searchDetails(this.props.searchStr);
        this.props.quickSearchClear();
    }

    populateSearchString(searchString) {
        //do nothing
        this.props.quickSearchTyped(searchString);
    }

    callQuickSearch(searchStr, event) {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
            if (event.key === 'Enter' && Object.keys(this.props.results).length > 0) {
                this.props.openPatient(this.props.results[Object.keys(this.props.results)[0]].id);
                this.props.quickSearchClear();
            } else if (event.key === 'Escape') {
                this.props.quickSearchClear();
            } else {
                this.props.quickSearch(searchStr)
            }
        }, 500);
    }

    handleKeyPress(event) {
        if (event.key === 'Enter' && Object.keys(this.props.results).length > 0) {
            this.props.openPatient(this.props.results[Object.keys(this.props.results)[0]].id);
            this.props.quickSearchClear();
        }
    }

    handleKeyDown(event) {
        if (event.key === 'Escape') {
            this.props.quickSearchClear();
        }
    }

    renderSearchResults() {
        if (this.props.loading) {
            return (<div className={styles.results} style={{ paddingLeft: 20 }}><i>Loading...</i></div>);
        } else if (this.props.searchStr.length < 3) {
            return (<div></div>)
        } else if (this.props.results && Object.keys(this.props.results).length > 0) {
            return (
                <div className={styles.results}>
                    {Object.keys(this.props.results)
                        .sort((a, b) => this.props.results[a].details.localeCompare(this.props.results[b].details))
                        .map(id => {
                            const result = this.props.results[id];
                            return <SearchResult key={result.id} id={result.id} />
                        })
                    }
                </div>
            )
        } else if (this.props.results && Object.keys(this.props.results).length === 0 && this.props.searchStr.length > 2) {
            return (<div className={styles.results} style={{ paddingLeft: 20 }}><i>No Results</i></div>);
        }
    }

    render() {
        return (
            <div>
                <div className={styles.contents}>
                    <input className={styles.input} type="text" placeholder="Search Here" onChange={event => this.populateSearchString(event.target.value)} onKeyUp={event => this.callQuickSearch(event.target.value, event)} value={this.props.searchStr} />
                    <span onClick={() => this.searchDetails()}><FontAwesomeIcon className={styles.icon} icon={faSearch} /></span>
                </div>
                {this.renderSearchResults()}
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        searchStr: state.ui.quickSearch.searchStr,
        results: state.entities.quickSearch,
        loading: state.ui.quickSearch.loading,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        quickSearch: bindActionCreators(searchActions.quickSearch, dispatch),
        quickSearchTyped: bindActionCreators(searchActions.quickSearchTyped, dispatch),
        quickSearchClear: bindActionCreators(searchActions.quickSearchClear, dispatch),
        searchDetails: bindActionCreators(searchActions.searchDetails, dispatch),
        openPatient: bindActionCreators(patientActions.open, dispatch),
        timeout: 0
    };
}

const connectedHeaderSearch = connect(mapStateToProps, mapDispatchToProps)(HeaderSearch);
export { connectedHeaderSearch as HeaderSearch };

